import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { WebsiteThemeService } from '../../../services/website-theme.service';
import { Router } from "@angular/router";
import { ComponentService } from "../../../services/component.service";
import { LocationStrategy } from "@angular/common";
import { SharedHttp } from "../../../services/http-client.service";
import { AuthenticationWalletModalComponent } from "../authentication-wallet-modal/authentication-wallet-modal.component";
import { WebClientService } from "../../../services/webclient-settings.service";
import { LimitExceededModalWalletComponent } from "../limit-exceeded-modal-wallet/limit-exceeded-modal-wallet.component";
import { UtilityService } from "../../../services/utility.service";
import { DepositOriginService } from '../../../services/deposit-origin.service';
import { isDepositOriginCode } from '../../../services/deposit-origin';
/**
 * Sell Wallet Modal Component
 */
let SellWalletModalComponent = class SellWalletModalComponent {
    constructor(sanitizer, router, httpClient, compService, location, themeService, webSettingsService, utilityService, depositOriginService) {
        this.sanitizer = sanitizer;
        this.router = router;
        this.httpClient = httpClient;
        this.compService = compService;
        this.location = location;
        this.themeService = themeService;
        this.webSettingsService = webSettingsService;
        this.utilityService = utilityService;
        this.depositOriginService = depositOriginService;
        this.secondColor = '';
        this.accentColor = '';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.errorColor = '';
        this.destinationWalletInput = '';
        this.maxValidAmount = true;
        this.minValidAmount = true;
        this.sendButtonDisabled = true;
        this.activeCurrency = localStorage.getItem('defaultCurrency').toLowerCase();
        this.destinationWalletExpanded = false;
        this.loaded = false;
        this.prices = {};
        this.sendButtonClicked = false;
        this.withdrawError = false;
        this.errorMessage = '';
        this.user = JSON.parse(localStorage.getItem('user'));
        this.minAmount = 0;
        this.maxAmount = 0;
        this.feePercentage = 0;
        this.minFee = 0;
        this.marketFee = 0;
        this.fixedFee = 0;
        this.price = 0;
        this.fee = 0;
        this.step = 1;
        this.decimalStep = '';
        this.orderAlreadyCreatedError = false;
        this.themeService.getTheme().subscribe((data) => {
            this.secondColor = this.themeService.getStyleAttribute('secondary_text_color');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
        });
        location.onPopState(() => {
            this.close();
        });
    }
    ngOnInit() {
        this.webSettingsService.getSettings().subscribe((data) => {
            this.fiatLotSize = this.webSettingsService.getCustomValue('FIAT_CURRENCY_LOT_SIZE') ? this.webSettingsService.getCustomValue('FIAT_CURRENCY_LOT_SIZE') : 2;
        });
        this.getPrices();
        this.getFiatWallet();
        this.getMarketSettings();
        this.getMarketFee();
        this.getLotSizeIfMarketIsBinance();
        this.intervalId = setInterval(() => {
            this.getWallet();
            if (this.step == 1) {
                this.getPrices();
            }
        }, 15000);
    }
    ngOnDestroy() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    }
    close() {
        this.modal.destroy();
    }
    allowDecimalPoints(event) {
        if (this.allowedDecimalPlaces > 0) {
            const splitVal = event.target.value.split('.');
            if (splitVal.length === 2 && splitVal[1].length >= this.allowedDecimalPlaces) {
                const isNumber = /^[0-9]$/i.test(event.key);
                if (isNumber) {
                    event.preventDefault();
                }
            }
        }
        else if (this.allowedDecimalPlaces === 0) {
            if (event.key === ".") {
                event.preventDefault();
            }
        }
    }
    checkValidation(skipCalculation = false) {
        if (!this.amount || typeof this.amount === 'undefined' || this.amount <= 0) {
            this.minValidAmount = true;
            this.maxValidAmount = true;
            if (!this.amount) {
                this.amountReceive = null;
            }
            this.lastAmount = null;
            this.sendButtonDisabled = true;
            return;
        }
        if (this.amount < this.minAmount) {
            this.minValidAmount = false;
            this.maxValidAmount = true;
            this.sendButtonDisabled = true;
            return;
        }
        if (this.amount > this.data.walletData.spendableTotal || this.amount > this.maxAmount) {
            this.minValidAmount = true;
            this.maxValidAmount = false;
            this.sendButtonDisabled = true;
            return;
        }
        if (!skipCalculation && this.amount !== this.lastAmount) {
            this.price = (this.amount * this.currencyPrice) / 100 * (100 - this.marketFee);
            this.fee = (this.price / 100 * this.feePercentage) + this.fixedFee;
            if (this.minFee > this.fee) {
                this.fee = this.minFee;
            }
            this.amountReceive = Number((this.price - this.fee).toFixed(this.fiatLotSize));
            this.lastAmount = this.amount;
        }
        this.minValidAmount = true;
        this.maxValidAmount = true;
        if (!this.destinationWalletInput) {
            return;
        }
        this.sendButtonDisabled = false;
    }
    confirmSell() {
        this.step = 2;
    }
    sellCoins() {
        if (this.sendButtonDisabled || this.orderAlreadyCreatedError) {
            return;
        }
        this.sendButtonClicked = true;
        this.withdrawError = false;
        const sellData = {
            walletId: this.data.walletData.verboseId,
            destinationWalletId: this.destinationWallet.verboseId,
            baseCurrencyAmount: this.amount,
            quoteCurrencyAmount: this.amountReceive,
            baseCurrency: this.data.walletData.currency.verboseId,
            quoteCurrency: this.destinationWallet.currency.verboseId,
        };
        this.httpClient.post('wallet/sell', sellData).subscribe((data) => {
            this.close();
            this.compService.openModal(AuthenticationWalletModalComponent, {
                authenticated: true,
                type: 'internal_sell',
                isSuccess: true
            });
        }, (error) => {
            this.errorMessage = error.error['message'];
            if (isDepositOriginCode(this.errorMessage)) {
                // the deposit trigger wants the statement or the proof of origin: its window instead of an error
                this.close();
                this.depositOriginService.openForCode(this.errorMessage);
                return;
            }
            if (this.errorMessage === 'ORDER_ALREADY_CREATED') {
                this.orderAlreadyCreatedError = true;
                setTimeout(() => {
                    this.orderAlreadyCreatedError = false;
                }, 30000);
            }
            else {
                this.withdrawError = true;
            }
            this.sendButtonClicked = false;
            if (this.errorMessage === 'USER_WEEKLY_LIMIT_LITE_EXCEEDED' || this.errorMessage === 'USER_MONTHLY_LIMIT_LITE_EXCEEDED' || this.errorMessage === 'USER_YEARLY_LIMIT_LITE_EXCEEDED') {
                this.close();
                this.compService.openModal(LimitExceededModalWalletComponent);
            }
        });
    }
    getMaxAmount() {
        this.amount = this.utilityService.truncateDataBasedOnPrecision(this.data.walletData.spendableTotal, this.allowedDecimalPlaces);
        this.amountReceive = this.amount * this.currencyPrice;
        this.lastAmount = null;
        this.checkValidation();
    }
    expandDestinationWallet() {
        this.destinationWalletExpanded = !this.destinationWalletExpanded;
    }
    fillDestinationWallet(destinationWalletInput, destinationWallet) {
        let fiatWalletLanguageValue = this.webSettingsService.getKeyValue('WALLET.WALLET');
        this.destinationWalletInput = destinationWalletInput + ' ' + fiatWalletLanguageValue;
        this.destinationWallet = destinationWallet;
        this.fiatWalletAmount = destinationWallet.spendableTotal;
        this.activeCurrency = destinationWalletInput.toLowerCase();
        this.checkValidation();
    }
    getWallet() {
        this.httpClient.get('wallet/getwallet?customerWalletId=' + this.data.walletData.verboseId).subscribe((data) => {
            if (data['wallet']) {
                this.data.walletData.spendableTotal = data['wallet']['spendableTotal'];
            }
        });
    }
    getPrices() {
        this.httpClient.get('market/pricesforwallet').subscribe((data) => {
            this.currencyPrice = Number(data[this.activeCurrency + '_prices'][this.data.walletData.currency.verboseId.toLowerCase()]);
            this.loaded = true;
        });
    }
    getFiatWallet() {
        for (let i = 0; i < this.data.fiatWallets.length; i++) {
            if (this.data.fiatWallets[i].wallet.currency.verboseId == this.activeCurrency.toUpperCase()) {
                this.fillDestinationWallet(this.data.fiatWallets[i].wallet.currency.verboseId, this.data.fiatWallets[i].wallet);
                break;
            }
        }
    }
    getMarketSettings() {
        let userType = this.user.user_type_id.type;
        let isIndividual = this.user.is_company_user ? 0 : 1;
        let meansOfPayment = 'bank_slip';
        let orderType = 'internal_sell';
        this.httpClient.get('wallet/getmarketsettings?baseCurrency=' + this.data.walletData.currency.verboseId.toLowerCase() + '&meanOfPayment=' + meansOfPayment + '&userType=' + userType + '&orderType=' + orderType + '&isIndividual=' + isIndividual).subscribe((data) => {
            this.minAmount = Number(data['min_amount']);
            this.maxAmount = Number(data['max_amount']);
            this.feePercentage = Number(data['fee']);
            this.minFee = Number(data['min_fee']);
            this.fixedFee = Number(data['fixed_fee']);
        });
    }
    getMarketFee() {
        this.httpClient.get('order/marketfee').subscribe((data) => {
            this.marketFee = data['message'];
        });
    }
    getLotSizeIfMarketIsBinance() {
        let orderType = 'internal_sell';
        this.httpClient.get('market/getallowednumberofdecimals/' + this.data.walletData.currency.verboseId.toLowerCase() + '/' + orderType).subscribe((data) => {
            this.allowedDecimalPlaces = data['lotSize'] != null ? data['lotSize'] : this.webSettingsService.getWebSetting("WALLET.NUMBER_OF_DECIMALS_BUY_SELL");
            for (let i = 1; i <= this.allowedDecimalPlaces; i++) {
                this.decimalStep += i != this.allowedDecimalPlaces ? '0' : '1';
            }
        }, (error) => {
            this.allowedDecimalPlaces = this.webSettingsService.getWebSetting("WALLET.NUMBER_OF_DECIMALS_BUY_SELL");
        });
    }
};
SellWalletModalComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: Router },
    { type: SharedHttp },
    { type: ComponentService },
    { type: LocationStrategy },
    { type: WebsiteThemeService },
    { type: WebClientService },
    { type: UtilityService },
    { type: DepositOriginService }
];
SellWalletModalComponent = __decorate([
    Component({
        selector: 'ecd-sell-wallet-modal',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./sell-wallet-modal.component.html")).default
    })
], SellWalletModalComponent);
export { SellWalletModalComponent };
